<div class="modal-header">
  <h4>{{ title }}</h4>
  <button type="button" class="close" (click)="onDismiss()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <div class="container-xxl">
    <div class="row">
      <p>Informe abaixo o motivo da reprovação</p>
    </div>
  </div>
  <textarea [(ngModel)]="reproveReason" type="text" class="form-control" maxlength="250"></textarea>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="onConfirm()" rippleEffect>
    Confirmar
  </button>
  <button type="button" class="btn btn-outline-danger" (click)="onDismiss()" rippleEffect>
    Cancelar
  </button>
</div>